export enum SubHeaderLevels {
    Level1 = "1",
    Level2 = "2",
    Level3 = "3",
    Deprecated = "4",
}

export enum SubHeaderColors {
    primary = "primary",
    secondary = "secondary",
    link = "link",
}

export type SubHeaderColorValues = SubHeaderColors.primary | SubHeaderColors.secondary | SubHeaderColors.link;

export type SubHeaderLevelValues =
    | SubHeaderLevels.Level1
    | SubHeaderLevels.Level2
    | SubHeaderLevels.Level3
    | SubHeaderLevels.Deprecated;
